import React from "react";
import { Link } from "react-router-dom";

/**
 * Toletforrent brand lockup.
 *
 * The source artwork is a single flattened PNG, but its tagline is only 28px
 * of 394 (7% of the height) — at any realistic UI size that renders ~3px tall
 * and is unreadable. So the mark and wordmark are cropped into separate assets
 * and the tagline is rendered as real text, free to be sized independently.
 *
 * variant:
 *   - "full"     → mark + wordmark (default)
 *   - "mark"     → house mark only (compact / collapsed states)
 *   - "wordmark" → wordmark only
 *
 * tone: "dark" (on light bg, default) or "light" (on dark bg — the wordmark
 * is filtered to solid white, since the artwork's ink is near-black).
 */
const Logo = ({
  variant = "full",
  tone = "dark",
  size = 36,
  to = "/",
  className = "",
  showTagline = false,
}) => {
  const wordmarkHeight = Math.round(size * 0.52);
  const taglineColor = tone === "light" ? "text-white/70" : "text-gray-500";
  const wordmarkFilter = tone === "light" ? "brightness-0 invert" : "";

  const Mark = (
    <img
      src="/assets/images/logo-mark.png"
      alt=""
      width={152}
      height={160}
      style={{ height: size, width: "auto" }}
      className="shrink-0"
    />
  );

  const Wordmark = (
    <span className="flex flex-col justify-center leading-none">
      <img
        src="/assets/images/logo-wordmark.png"
        alt=""
        width={614}
        height={96}
        style={{ height: wordmarkHeight, width: "auto" }}
        className={wordmarkFilter}
      />
      {showTagline && (
        <span
          className={`mt-[3px] font-semibold uppercase tracking-[0.16em] whitespace-nowrap ${taglineColor}`}
          style={{ fontSize: Math.max(9, Math.round(size * 0.24)) }}
        >
          Find your perfect home
        </span>
      )}
    </span>
  );

  const inner = (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {(variant === "full" || variant === "mark") && Mark}
      {(variant === "full" || variant === "wordmark") && Wordmark}
    </span>
  );

  if (!to) return inner;
  return (
    <Link
      to={to}
      aria-label="Toletforrent — find your perfect home"
      className="hover:opacity-90 transition"
    >
      {inner}
    </Link>
  );
};

export default Logo;
